import React from 'react';

// Accessible on/off switch (handoff 11). Purely presentational + controlled:
// deep-green when on, grey when off, sliding knob. Matches the prototype
// profile.html Consents card toggle.
export default function ConsentToggle({ checked, onChange, busy, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={busy}
      onClick={() => !busy && onChange(!checked)}
      className={
        'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ' +
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#043132] focus-visible:ring-offset-2 ' +
        'disabled:opacity-50 disabled:cursor-not-allowed ' +
        (checked ? 'bg-[#043132]' : 'bg-slate-300')
      }
    >
      <span
        className={
          'inline-block h-5 w-5 rounded-full bg-white shadow transform transition-transform ' +
          (checked ? 'translate-x-[22px]' : 'translate-x-0.5')
        }
      />
    </button>
  );
}
